import React from 'react'
import { ReactSupervisor } from 'react-supervisor';
import FormRenderer from './renderer'


ReactSupervisor.registerComponent(".renderer", FormRenderer)
ReactSupervisor.initialize();
